import './Loading.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
function Loading() {

    const {isLoading} = useTypedSelector(state => state.game);

    let loadingClass = 'battleLoadingHide';
    if(isLoading){
        loadingClass += ' battleLoadingVisible';
    }

    return (
        <div className={loadingClass}>
            <div id='battleLoading'></div>
        </div>
    )
}

export default Loading;